import axios from "axios";

let api = {
  url: "",
  authToken: "",
  dataToken: "",
  router: null,
  init(url: string, oktaToken: string, token: string, router: any) {
    this.url = url;
    this.authToken = oktaToken;
    this.dataToken = token;
    this.router = router;
    return this;
  },
  call: (
    method: string,
    path: string,
    params: Record<string, any>,
    headers: Record<string, string> = {}
  ) => {
    return new Promise((accept: Function, reject: Function) => {
      let config: Record<string, any> = {
        method: method,
        url: `${api.url}${path}`,
        headers: headers
      };
      headers["Ocp-Apim-Subscription-Key"] = process.env.VUE_APP_AZURE_APIM_ID;
      headers["Authorization"] = `Bearer ${api.authToken}`;

      if (api.dataToken) {
        headers["x-data-token"] = api.dataToken;
      }

      if (method === "get") {
        config.params = params;
      } else {
        config.data = params;
      }

      axios(config)
        .then(resp => accept(resp.data))
        .catch(error => {
          if (error && error.response && error.response.status === 401) {
            api.router.push("/")
          }

          reject((error && error.response && error.response.data) || error)
        });
    });
  },
  callFile: (method: string, path: string, data: Record<string, any>, headers: Record<string, string> = {}) => {
    if (["get"].indexOf(method) >= 0) {

      return new Promise((accept: Function, reject: Function) => {

        headers["Authorization"] = `Bearer ${api.authToken}`;

        if (api.dataToken) {
          headers["x-data-token"] = api.dataToken;
          headers["Ocp-Apim-Subscription-Key"] = process.env.VUE_APP_AZURE_APIM_ID;
          headers["Content-Disposition"]="attachment";
        }

        let config: Record<string, any> = {
          method: method,
          url: `${api.url}${path}`,
          headers: headers,
          responseType: "blob"
        };

        axios
          .get(`${path}`, config)
          .then(resp => accept(resp.data))
          .catch(error => {
            if (error && error.response && error.response.status === 401) {
              api.router.push("/")
            }

            reject((error && error.response && error.response.data) || error)
          });
      });
    } else {
      return new Promise((accept: Function, reject: Function) => {
        let headers: Record<string, string> = {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${api.authToken}`
          //'Content-Type': application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
        };

        if (api.dataToken) {
          headers["x-data-token"] = api.dataToken;
          headers["Ocp-Apim-Subscription-Key"] = process.env.VUE_APP_AZURE_APIM_ID;
        }

        axios
          .post(`${api.url}${path}`, data, { headers })
          .then(resp => accept(resp.data))
          .catch(error => {
            if (error && error.response && error.response.status === 401) {
              api.router.push("/")
            }

            reject((error && error.response && error.response.data) || error)
          });
      });
    }
  }
};

export default api;
